"use client"

import { useEffect, useRef } from "react"

import { ProductPreviewTemplate } from "@/features/product/summary/components/ProductPreviewTemplate"
import type { ThumbnailSize } from "@/features/product/summary/components/Thumbnail"
import { useInView } from "@/lib/hooks/use-in-view"

interface ProductPreviewTemplateWrapperProps {
  title: string
  thumbnail?: string | null
  thumbnailSize?: ThumbnailSize
  href?: string
  percentageDiscount?: number
  isFeatured?: boolean
  hasFreeShipping?: boolean
  originalPrice?: string
  calculatedPrice?: string
  pagosPriceLabel?: string
  onClick?: () => void
  rating: {
    count_responses: number
    average_rating: number
  } | null
  onInView?: () => void
}

const ProductPreviewWithInView = ({ onInView, children }: { onInView: () => void; children: React.ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, "0px", 0.75, 1000)

  useEffect(() => {
    if (inView) {
      onInView()
    }
  }, [inView, onInView])

  return <div ref={ref}>{children}</div>
}

export const ProductPreviewTemplateWrapper = ({
  title,
  href = "/",
  thumbnail,
  thumbnailSize = "full",
  isFeatured,
  percentageDiscount,
  hasFreeShipping,
  originalPrice,
  calculatedPrice,
  pagosPriceLabel,
  rating,
  onClick,
  onInView,
}: ProductPreviewTemplateWrapperProps) => {
  const content = (
    <ProductPreviewTemplate
      title={title}
      href={href}
      thumbnail={thumbnail}
      thumbnailSize={thumbnailSize}
      isFeatured={isFeatured}
      percentageDiscount={percentageDiscount}
      hasFreeShipping={hasFreeShipping}
      originalPrice={originalPrice}
      calculatedPrice={calculatedPrice}
      pagosPriceLabel={pagosPriceLabel}
      rating={rating}
      onClick={onClick}
    />
  )

  if (onInView) {
    return <ProductPreviewWithInView onInView={onInView}>{content}</ProductPreviewWithInView>
  }

  return content
}
